import { render, staticRenderFns } from "./pkgCategory.vue?vue&type=template&id=53c699a3&scoped=true&"
import script from "./pkgCategory.vue?vue&type=script&lang=js&"
export * from "./pkgCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c699a3",
  null
  
)

export default component.exports